/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Freebsd_DescInputs */

const en_pc_dl_file_freebsd_desc = /** @type {(inputs: Pc_Dl_File_Freebsd_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plain binaries. Unpack into /usr/local.`)
};

const zh_pc_dl_file_freebsd_desc = /** @type {(inputs: Pc_Dl_File_Freebsd_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`纯二进制文件，解压到 /usr/local。`)
};

/**
* | output |
* | --- |
* | "Plain binaries. Unpack into /usr/local." |
*
* @param {Pc_Dl_File_Freebsd_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_freebsd_desc = /** @type {((inputs?: Pc_Dl_File_Freebsd_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Freebsd_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_freebsd_desc(inputs)
	return zh_pc_dl_file_freebsd_desc(inputs)
});
export { pc_dl_file_freebsd_desc as "pc.dl.file.freebsd.desc" }